import { Bounds, LatLngBounds, Point } from 'leaflet';
import type { Map as LeafletMap } from 'leaflet';

/**
 * Prinzipiell das Gleiche wie map.getBoundsZoom, nur ohne Begrenzung auf MinZoom und MaxZoom
 */
export function getBoundsZoomUnbounded(map: LeafletMap, bounds: LatLngBounds) {
  const zoom = map.getZoom() || 0;
  const nw = bounds.getNorthWest();
  const se = bounds.getSouthEast();
  const size = map.getSize();
  const boundsSize = toBounds(
    map.project(se, zoom),
    map.project(nw, zoom),
  ).getSize();
  const scalex = size.x / boundsSize.x;
  const scaley = size.y / boundsSize.y;
  const scale = Math.min(scalex, scaley);

  const resultZoom = map.getScaleZoom(scale, zoom);
  return resultZoom;
}

function toBounds(a: Point, b: Point) {
  return new Bounds(a, b);
}
